import { render, staticRenderFns } from "./NormalOrderCart.vue?vue&type=template&id=50b457ff"
import script from "./NormalOrderCart.vue?vue&type=script&lang=js"
export * from "./NormalOrderCart.vue?vue&type=script&lang=js"
import style0 from "./NormalOrderCart.vue?vue&type=style&index=0&id=50b457ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports